import React, { FunctionComponent } from 'react';

import { usePageOwner } from '../../hooks/usePageOwner';

const IsPageOwner: FunctionComponent = ({ children }) => {
  const { isPageOwner } = usePageOwner();

  return isPageOwner ? <>{children}</> : null;
};

export default IsPageOwner;
